import {Box, Stack, styled} from '@mui/material';

type StyledFooterContainerProps = {
	$mb?: number;
};

const SearchStrip = styled(Box)`
	width: 100%;
	flex-shrink: 0;
`;

const StyledStack = styled(Stack)`
	padding: 24px 16px;
	gap: 16px;
	width: 100%;
	min-height: 0;
	box-sizing: border-box;

	${({theme}) => theme.breakpoints.up('sm')} {
		padding: 24px 32px;
	}
`;

const StyledGrid = styled(Box)`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 16px;
	align-items: flex-start;

	${({theme}) => theme.breakpoints.down('md')} {
		grid-template-columns: repeat(2, 1fr);
		column-gap: 24px;
	}

	${({theme}) => theme.breakpoints.down('sm')} {
		grid-template-columns: 1fr;
	}
`;

const StyledFooterContainer = styled(Box)<StyledFooterContainerProps>`
	margin: ${props => (props.$mb ? `auto 0px ${props.$mb}px` : 'auto 0px 16px')};
	padding-top: 40px;

	${({theme}) => theme.breakpoints.up('sm')} {
		margin: auto 0px 0px;
		& footer {
			margin-inline: 24px;
		}
	}

	${({theme}) => theme.breakpoints.up('md')} {
		margin: auto 24px 0px;
		& footer {
			margin-inline: 0px;
		}
	}
`;

const FiltersContainer = styled(Stack)`
	width: 100%;
	padding: 0px 0px;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	gap: 8px;
	flex-wrap: wrap;
`;

export {FiltersContainer, SearchStrip, StyledStack, StyledGrid, StyledFooterContainer};
